import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import Page from "../../components/Page";
import { backendUrl } from "../../constants";
import userLogo from "../../assets/jobSeeker.png";
import "./styles.css";
import { useParams } from "react-router-dom";
import { Anchor, Flex, Group, Loader, Text } from "@mantine/core";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import Button from "../../components/Button";
import { userData } from "../../Helpers";
import { List, Stack } from "@mantine/core";
import { loadCompanyData } from "./loadData";
import { AspectRatio } from "@mantine/core";
import moment from "moment/moment";
import { FaBeer } from "react-icons/fa";
import { Carousel } from "@mantine/carousel";
import Autoplay from "embla-carousel-autoplay";
import { CurrentLocation } from "tabler-icons-react";
import { UserExclamation } from "tabler-icons-react";
import { PhotoMinus } from "tabler-icons-react";
import { Video } from "tabler-icons-react";
import { Books } from 'tabler-icons-react';
import { Link } from 'tabler-icons-react';

import {
  followFunction,
  initiateChatWithUser,
  unfollowFunction,
} from "../../JobSeekerPages/jobSeekerHelperFunctions/jobseekerHelpers";

const Index = ({}) => {
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  console.log("data", data);


  //get profile data
  useEffect(() => {
    loadCompanyData(id, setLoading).then(setData);
  }, [id, refresh]);

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <LoaderWrapper loading={loading}>
        <div className="viewProfile">
          <Flex gap={"md"} direction={"column"} style={{ width: "30%" }}>
            <div className="profile-1 shadow">
              <img
                src={
                  (data &&
                    data?.data?.[0]?.companyProfileInfo?.[0]?.companyLogo) ||
                  userLogo
                }
                width="60%"
                height="45%"
                className="rounded-circle"
                style={{ border: "2px solid gray" }}
                alt=""
              />
              <h4 className="text-dark mb-0">
                {" "}
                {data && data?.data?.[0]?.companyProfileInfo?.[0]?.companyName}
              </h4>
              <p style={{ fontSize: "14px" }}>
                {data &&
                  data?.data?.[0]?.companyProfileInfo?.[0]?.companyTagLine}
              </p>
              <p style={{ color: "rgb(0,0,0,0.4)" }} className="m-0">
                {" "}
                {data?.data?.[0]?.address1} , {data?.data?.[0]?.zipCode}
              </p>

              <p style={{ color: "rgb(0,0,0,0.4)" }} className="mt-0">
                {data?.data?.[0]?.companyAbout?.[0]?.employees?.lookupName}{" "}
                Employees
              </p>

              <Group position="center" mt="md">
                {" "}
                <Button
                  title={"Message"}
                  fontWeight="700"
                  width="92px"
                  onClick={() => {
                    initiateChatWithUser(id);
                  }}
                />
                {data?.followingList
                  ?.map((followingList) => {
                    if (followingList.user === userData.id) {
                      return followingList.user;
                    }
                  })
                  .includes(userData.id) ? (
                  <Button
                    onClick={() => {
                      unfollowFunction(id, setLoading, refresh, setRefresh);
                    }}
                    title={"Unfollow"}
                    fontWeight="700"
                    width="90px"
                  />
                ) : (
                  <div className="d-flex justify-content-evenly">
                    <Button
                      onClick={() => {
                        followFunction(id, setLoading, refresh, setRefresh);
                      }}
                      title={"Follow"}
                      primary={true}
                      fontWeight="700"
                      width="90px"
                    />
                  </div>
                )}
              </Group>
            </div>
          </Flex>

          <div className="profile-2">
            <div className="profile-2-2 shadow">
              <h6 className="head1">
                {<UserExclamation size={25} strokeWidth={2} />} COMPANY SUMMARY
              </h6>

              <Text ml="xl" size={16} py="md">
                {" "}
                {data?.data?.[0]?.companyAbout?.[0]?.companyDescription}
              </Text>
            </div>

            {/* <div className="profile-2-1">
              <div className="video shadow">
                <h6 className="head1">EXPERIENCE</h6>
                {data?.jobSeeker?.[0]?.jobSeekerEmploymentHistory.length === 0 ? (
                  <p className="px-3 py-1">No Education Details</p>
                ) : (
                  data?.jobSeeker?.[0]?.jobSeekerEmploymentHistory.map((obj) => (
                    <List ml="xl" size="md">
                      <List.Item>
                        <Stack py={3} m={0} spacing={0}>
                          <Text weight={600}>{obj?.jobTitle}</Text>
                          <Group noWrap m={0} p={0} spacing={2}>
                            <Text size={13.5}>({moment(obj?.startDate).format("YYYY")}-{moment(obj?.startDate).format("YYYY")})</Text>
          
                          </Group>
                        </Stack>
                      </List.Item>
                    </List>
                  ))
                )}
              </div>

              <div className="video shadow">
                <h6 className="head1">EDUCATION</h6>
                {data?.jobSeeker?.[0]?.jobSeekerEducation.length === 0 ? (
                  <p className="px-3 py-1">No Education Details</p>
                ) : (
                  data?.jobSeeker?.[0]?.jobSeekerEducation.map((obj) => (
                    <List ml="xl" size="md">
                      <List.Item>
                        <Stack py={3} m={0} spacing={0}>
                          <Text weight={600}>{obj?.degree?.degreeName}</Text>
                          <Group noWrap m={0} p={0} spacing={2}>
                            <Text  size={13.5}>{obj?.school?.lookupName}</Text>
                            <Text> | </Text>
                            <Text  size={13.5}>{obj?.state?.lookupName}</Text>
                          </Group>
                        </Stack>
                      </List.Item>
                    </List>
                  ))
                )}
              </div>
            </div> */}
            <div className="profile-2-2 shadow">
              <h6 className="head1">
                {
                  <CurrentLocation
                    size={25}
                    strokeWidth={2}
                    // color={'#404abf'}
                  />
                }{" "}
                LOCATIONS
              </h6>

              {data && data?.locations.length === 0 ? (
                <Text ml="xl" size="md" py="md">
                  No locations Added
                </Text>
              ) : (
                <List ml="xl" size={16} py="md">
                  {data &&
                    data?.locations.map((obj) => (
                      <List.Item>
                        {obj?.locationName}, {obj?.city}
                      </List.Item>
                    ))}
                </List>
              )}
            </div>
            <div className="profile-2-2 shadow">
              <h6 className="head1">
                {
                  <Books
                    size={25}
                    // strokeWidth={2}
                    // color={'#404abf'}
                  />
                }{" "}
                CORPORATE CULTURE
              </h6>
              <Text ml="xl" size={16} py="md">
                {" "}
                {data?.data?.[0]?.companyCoorporate[0]?.corporateCultureSummary}
              </Text>
            </div>
            <div className="profile-2-2 shadow">
              <h6 className="head1">
                <PhotoMinus size={25} strokeWidth={2} /> PHOTO GALLERY
              </h6>
              {data?.data?.[0]?.companyCoorporate[0]?.companyGallery.length >
              0 ? (
                <div className="d-flex flex-column jsutify-content-center">
                  <Carousel
                    // plugins={[Autoplay?.current]}
                    // onMouseEnter={Autoplay?.current?.stop}
                    // onMouseLeave={Autoplay?.current?.reset}
                    loop
                    slideGap="md"
                    slidesToScroll={1}
                    controlSize={40}
                  >
                    {data?.data?.[0]?.companyCoorporate[0]?.companyGallery.map(
                      (obj, key) => (
                        <Carousel.Slide className="m-2" key={key}>
                          <div className="img-slidee">
                            <img src={obj?.fileName} width="80%" alt="" />
                          </div>
                        </Carousel.Slide>
                      )
                    )}
                  </Carousel>
                  <p className=" p-3 text-center ">
                    {data?.data?.[0]?.companyCoorporate[0]?.photoGalleryTitle}
                  </p>
                </div>
              ) : (
                <Text ml="xl" size={16} py="md">
                  No GalleryFound
                </Text>
              )}
            </div>
            <div className="profile-2-2 shadow">
              <h6 className="head1">
                {
                  <Video
                    size={25}
                    strokeWidth={2}
                    
                  />
                }{" "}
                PROFILE VIDEO
              </h6>
              <iframe
                width="100%"
                height="300"
                src="https://www.youtube.com/embed/tgbNymZ7vqY"
              ></iframe>
            </div>

            {/* <div className="profile-2-2 shadow">
              <h6 className="head1">LANGUAGES</h6>
              <div className="ml-2">
                {data?.jobSeeker?.[0]?.jobSeekerLanguages.length === 0 ? (
                  <Text ml="xl" size="md" py="md" >No Education Added</Text>
                ) : (
                  <List ml="xl" size="md" py="md">
                    {data?.jobSeeker?.[0]?.jobSeekerLanguages?.[0]?.language.map(
                      (obj) => (
                        <List.Item>{obj.language?.lookupName}</List.Item>
                      )
                    )}
                  </List>
                )}
              </div>
            </div> */}

            {/* <div className="profile-2-1">
              <div className="ints shadow">
                <h6 className="head1">Interests</h6>
                {data?.jobSeeker?.[0]?.jobSeekerInterets.length === 0 ? (
                <Text ml="xl" size="md" py="md" >No Interests Added</Text>
              ) : (
                <List ml="xl" size="md" py="md">
                  {data?.jobSeeker?.[0]?.jobSeekerInterets?.[0]?.interest.map(
                    (obj,index) => (
                      <List.Item>{obj.interest?.interestName}</List.Item>
                    )
                  )}
                </List>
              )}
              </div>
              <div className="awards shadow">
                <h6 className="head1">Awards</h6>
                <p className="px-3 py-1"></p>
              </div>
            </div> */}
            <div className="profile-2-2 shadow">
              <h6 className="head1">{<Link size={25} strokeWidth={2}/>}LINKS</h6>

              <div className="d-flex flex-column  ">
                {data?.data?.[0]?.companyWebLinks.map((obj, key) => {
                  return (
                    obj.linkType && (
                      <div
                        key={key}
                        className="d-flex gap-2 m-2 pb-2 link-item"
                      >
                        <img
                          src={require(`../../assets/${obj?.linkType?.lookupName}.svg`)}
                          width="25px"
                          alt="logo"
                        />
                        <Anchor href={"http://"+obj?.linkURL}>{obj?.linkURL}</Anchor>
                      </div>
                    )
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </LoaderWrapper>
    </Page>
  );
};

export default withTranslation()(Index);
